/* HH free-gift guard (Cowork, hardened 7 Sep 2026 after order #HHO2859).
   The two bonus packs are real $0 published variants (the packer needs a
   pickable SKU line), so they can be added on their own, or left behind after
   the Grip-X line is removed, giving somebody a free box. This runs on every
   page (the cart drawer renders site-wide, including /cart) and:
     1) strips any bonus-pack line that has not been earned;
     2) on a bonus-pack PRODUCT page, disables the add-to-cart + dynamic-checkout
        buttons (belt and braces in case templates/product.gift.json is not
        applied to the product yet);
     3) shows a brief friendly note when it corrects the cart.
   Entitlement: 10+ Grip-X boxes -> 1x X2235BK pack; 20+ -> also 1x X2235.
   Client-side defence-in-depth only; the true lock is the server-side guard.

   25 Oct 2026 - BLACK NOVEMBER (owner brief, 24 Oct). While html.hh-bn is set (layout/
   theme.liquid) a different rule set runs, and it ADDS the gifts as well as policing them:
     - only ONE-TIME Grip-X boxes count (lines without a selling plan);
     - 10+ boxes: 1 x "Bonus - Hygiene Hub Air Freshener";
     - 20+ boxes: also 1 x "Bonus Pack - SE Premium Blue (X2235)", in the size they bought
       most of (else L). They can change the size in the cart drawer - the [data-hh-gsize]
       select that snippets/cart-drawer.liquid prints on a gift line with sizes;
     - one of each at most; gifts go when the boxes drop below the line, when the boxes are
       on a subscription, or when a gift arrives by URL without qualifying;
     - the everyday SE Premium Black pack is switched off for the month.
   Outside Black November the everyday rule is unchanged, plus the Black November air
   freshener product is never allowed in a cart (it is not an everyday gift). */
(function () {
  if (window.__hhGiftGuard) return;
  window.__hhGiftGuard = true;

  var GRIPX = ['heavy-duty-black-nitrile-gloves-50-pack', 'test-do-not-publish-grip-x-black-subscription-build'];
  var BK = 'free-gift-se-premium-black-nitrile-gloves-x2235bk';
  var BLUE = 'free-gift-se-premium-blue-nitrile-gloves-x2235';
  var FRESH = 'bonus-hygiene-hub-air-freshener';
  /* everyday: boxes of Grip-X (any purchase type) needed for one of each */
  var GIFTS = {};
  GIFTS[BK] = 10;
  GIFTS[BLUE] = 20;
  GIFTS[FRESH] = Infinity;
  /* Black November gift variants (owner brief) */
  var FRESH_ID = 53116373139743;
  var BLUE_IDS = { S: 52855174627615, M: 52855175151903, L: 52855175184671, XL: 52855175217439 };

  function bnLive() { return document.documentElement.classList.contains('hh-bn'); }

  /* Fly and Appstle patch window.fetch; use a clean one so our writes are not reprocessed */
  var nf = (function () {
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      (document.body || document.documentElement).appendChild(f);
      var ff = f.contentWindow && f.contentWindow.fetch;
      if (ff) return ff.bind(f.contentWindow);
    } catch (e) {}
    return window.fetch.bind(window);
  })();
  var ORIGIN = window.location.origin;
  var busy = false;
  var failedAt = {};   /* variant id -> time an auto-add failed, so a sold-out gift is not retried in a loop */

  function sections() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function post(url, body) {
    return nf(ORIGIN + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.status && d.status >= 400) throw new Error(d.description || 'cart error');
      return d;
    });
  }
  function render(data) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function' && data && data.sections) {
      cd.renderContents(data);
    } else if (/^\/cart/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  function notify(msg) {
    try {
      var el = document.getElementById('hh-gift-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'hh-gift-toast';
        el.setAttribute('role', 'status');
        el.style.cssText = 'position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:100000;max-width:90vw;background:#172a5e;color:#fff;font:600 13px/1.35 var(--font-body-family,sans-serif);padding:11px 16px;border-radius:10px;box-shadow:0 10px 30px -8px rgba(0,0,0,.45);opacity:0;transition:opacity .25s ease;pointer-events:none;text-align:center;';
        (document.body || document.documentElement).appendChild(el);
      }
      el.textContent = msg;
      requestAnimationFrame(function () { el.style.opacity = '1'; });
      clearTimeout(el.__hideT);
      el.__hideT = setTimeout(function () { el.style.opacity = '0'; }, 4200);
    } catch (e) {}
  }

  /* Everyday rule: one of each pack per line once the Grip-X count clears its minimum. */
  function planEveryday(items) {
    var gx = 0;
    items.forEach(function (i) { if (GRIPX.indexOf(i.handle) > -1) gx += i.quantity; });
    var fixes = [];
    items.forEach(function (i) {
      var min = GIFTS[i.handle];
      if (min === undefined) return;
      var allowed = gx >= min ? 1 : 0;
      if (i.quantity !== allowed) fixes.push({ key: i.key, quantity: allowed });
    });
    return { fixes: fixes, adds: [], removed: fixes.length > 0, msg: 'Free bonus boxes come with 10+ boxes of Grip-X. Cart updated.' };
  }

  /* Black November rule (see the header). */
  function planBN(items) {
    var gx = 0, sizes = {};
    items.forEach(function (i) {
      if (GRIPX.indexOf(i.handle) < 0 || i.selling_plan_allocation) return;
      gx += i.quantity;
      var sz = String(i.variant_title || '').trim().toUpperCase();
      sizes[sz] = (sizes[sz] || 0) + i.quantity;
    });
    var want = {};
    want[FRESH] = gx >= 10 ? 1 : 0;
    want[BLUE] = gx >= 20 ? 1 : 0;
    want[BK] = 0;
    var seen = {}, fixes = [], removed = false;
    items.forEach(function (i) {
      if (!Object.prototype.hasOwnProperty.call(want, i.handle)) return;
      var allow = seen[i.handle] ? 0 : want[i.handle];
      if (allow) seen[i.handle] = 1;
      if (i.quantity !== allow) {
        fixes.push({ key: i.key, quantity: allow });
        if (allow < i.quantity) removed = true;
      }
    });
    var adds = [];
    var now = Date.now();
    function canAdd(id) { return !failedAt[id] || now - failedAt[id] > 60000; }
    if (want[FRESH] && !seen[FRESH] && canAdd(FRESH_ID)) adds.push({ id: FRESH_ID, quantity: 1 });
    if (want[BLUE] && !seen[BLUE]) {
      var top = '', n = 0;
      Object.keys(sizes).forEach(function (k) { if (sizes[k] > n) { n = sizes[k]; top = k; } });
      /* 4 Nov 2026: the size picked under the tiles on the Grip-X page wins (assets/hh-sub-tiers.js) */
      var picked = ''; try { picked = localStorage.getItem('hh_bn_blue_size') || ''; } catch (e) {}
      var bid = BLUE_IDS[picked] || BLUE_IDS[top] || BLUE_IDS.L;
      if (canAdd(bid)) adds.push({ id: bid, quantity: 1 });
    }
    return { fixes: fixes, adds: adds, removed: removed, msg: 'Black November gifts come with 10+ boxes of Grip-X (one-time purchase). Cart updated.' };
  }

  /* fixes first (one /cart/update.js), then any adds (one /cart/add.js); the last call
     carries the drawer sections so there is a single re-render */
  function apply(plan) {
    var chain = Promise.resolve(null);
    if (plan.fixes.length) {
      var up = {};
      plan.fixes.forEach(function (f) { up[f.key] = f.quantity; });
      chain = chain.then(function () {
        return post('/cart/update.js', { updates: up, sections: plan.adds.length ? undefined : sections(), sections_url: window.location.pathname });
      });
    }
    if (plan.adds.length) {
      chain = chain.then(function () {
        return post('/cart/add.js', { items: plan.adds, sections: sections(), sections_url: window.location.pathname })
          ['catch'](function (err) {
            plan.adds.forEach(function (a) { failedAt[a.id] = Date.now(); });
            throw err;
          });
      });
    }
    return chain;
  }

  function check() {
    if (busy) return;
    busy = true;
    nf(ORIGIN + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var plan = bnLive() ? planBN(items) : planEveryday(items);
        if (!plan.fixes.length && !plan.adds.length) { busy = false; return; }
        apply(plan).then(function (data) {
          render(data);
          if (plan.removed) notify(plan.msg);
          busy = false;
        })['catch'](function () { busy = false; });
      })
      ['catch'](function () { busy = false; });
  }

  /* Gift size in the cart drawer (Black November SE Premium Blue box). Capture phase +
     stopPropagation: Dawn's <cart-drawer-items> treats EVERY change event inside it as a
     quantity edit and would post this variant id to /cart/change.js as a quantity. One
     /cart/update.js swaps the line: old key to 0, new size to 1. */
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-hh-gsize]') : null;
    if (!sel) return;
    e.stopPropagation();
    var key = sel.getAttribute('data-key');
    var vid = parseInt(sel.value, 10);
    if (!key || !vid) return;
    busy = true;
    sel.disabled = true;
    var up = {};
    up[key] = 0;
    up[vid] = 1;
    post('/cart/update.js', { updates: up, sections: sections(), sections_url: window.location.pathname })
      .then(function (d) { render(d); busy = false; })
      ['catch'](function () { sel.disabled = false; busy = false; });
  }, true);

  /* Task 4: on a bonus-pack product page, kill the buy path (button + dynamic checkout). */
  function neutraliseGiftPage() {
    if (!/\/products\/(free-gift-|bonus-)/.test(window.location.pathname)) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
      var btn = f.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        var lbl = btn.querySelector('span') || btn;
        lbl.textContent = 'Free with 10+ Grip-X boxes';
      }
      var pay = f.querySelector('.shopify-payment-button, shopify-payment-button');
      if (pay) pay.style.display = 'none';
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(check, 400); }

  function boot() {
    neutraliseGiftPage();
    check();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(schedule).observe(cd, { childList: true, subtree: true });
    }
    var form = document.getElementById('CartDrawer-Form') || document.querySelector('form[action$="/cart"]');
    if (form) form.addEventListener('change', schedule);
    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button, .quantity__button, .cart-remove-button')) schedule();
    }, true);
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, schedule);
      window.addEventListener(ev, schedule);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
